import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=a37c562c"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a37c562c')) {
      api.createRecord('a37c562c', component.options)
    } else {
      api.reload('a37c562c', component.options)
    }
    module.hot.accept("./Container.vue?vue&type=template&id=a37c562c", function () {
      api.rerender('a37c562c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/MultiSelectionBadge/Container.vue"
export default component.exports